<template>
    <v-dialog v-model="showDialog" max-width="900px" scrollable persistent>
        <v-card>
            <v-card-title class="headline primary_2 white--text">
                Create New Product
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pt-6">
                <v-form ref="productForm" v-model="valid">
                    <!-- Basic Information Section -->
                    <div class="text-h6 mb-4">Basic Information</div>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.name"
                                label="Product Name*"
                                :rules="$rules.REQUIRED_FIELD"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.title"
                                label="Product Title*"
                                :rules="$rules.REQUIRED_FIELD"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="formData.product_type_ids"
                                :items="productTypes"
                                item-text="loan_type"
                                item-value="id"
                                label="Product Types*"
                                :rules="requiredArrayRule"
                                multiple
                                chips
                                small-chips
                                deletable-chips
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.rank"
                                label="Rank"
                                :rules="rankRules"
                                type="number"
                                min="1"
                                hint="1 = shown first to users. Leave blank to add at the bottom."
                                persistent-hint
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.web_url"
                                label="Website URL*"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.utm_link"
                                label="UTM Link*"
                                :rules="$rules.REQUIRED_FIELD"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>

                    <!-- Loan Details Section -->
                    <div class="text-h6 mb-4">Loan Details</div>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="formData.interest_rate"
                                label="Interest Rate*"
                                placeholder="e.g., 10.5% - 15%"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="formData.tenure"
                                label="Tenure*"
                                placeholder="e.g., 12-60 months"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="formData.loan_upto"
                                label="Loan Amount (Up to)*"
                                placeholder="e.g., ₹10,00,000"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="4">
                            <v-switch
                                v-model="formData.is_active"
                                label="Is Active"
                                color="primary_2"
                                inset
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-switch
                                v-model="formData.flag_recomended"
                                label="Recommended Product"
                                color="success"
                                inset
                            ></v-switch>
                        </v-col>
                       <v-col cols="12" md="4">
                                <v-switch
                                    v-model="formData.enable_manual_application"
                                    label="Manual Application"
                                    color="orange"
                                    inset
                                ></v-switch>
                            </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <!-- Eligibility Details Section -->
                    <div class="text-h6 mb-4">Eligibility Details</div>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="formData.eligibility_details.product_type"
                                :items="productTypes"
                                item-text="loan_type"
                                item-value="id"
                                label="Product Type*"
                                :rules="requiredArrayRule"
                                multiple
                                chips
                                small-chips
                                deletable-chips
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.eligibility_details.cibil_score"
                                label="Minimum CIBIL Score*"
                                type="number"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.eligibility_details.minimum_age"
                                label="Minimum Age*"
                                type="number"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.eligibility_details.maximum_age"
                                label="Maximum Age*"
                                type="number"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.eligibility_details.minimum_income"
                                label="Minimum Income*"
                                type="number"
                                prefix="₹"
                                :rules="incomeRule"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formData.eligibility_details.maximum_income"
                                label="Maximum Income"
                                type="number"
                                prefix="₹"
                                :rules="incomeRule"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="formData.eligibility_details.employment_type"
                                :items="employmentTypes"
                                label="Employment Type*"
                                :rules="requiredArrayRule"
                                multiple
                                chips
                                small-chips
                                deletable-chips
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="formData.eligibility_details.salary_type"
                                :items="salaryTypes"
                                label="Salary Type*"
                                :rules="requiredArrayRule"
                                multiple
                                chips
                                small-chips
                                deletable-chips
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="includedPincodeInput"
                                label="Included Pincodes"
                                outlined
                                dense
                                maxlength="6"
                                hint="Type 6-digit pincode and press Enter"
                                persistent-hint
                                @input="includedPincodeInput = normalizePincode(includedPincodeInput)"
                                @keydown.enter.prevent="addIncludedPincode"
                            ></v-text-field>
                            <div v-if="formData.eligibility_details.pincode_list.length" class="mt-2">
                                <v-chip
                                    v-for="(pincode, index) in formData.eligibility_details.pincode_list"
                                    :key="'included-' + pincode + index"
                                    class="ma-1"
                                    close
                                    small
                                    @click:close="removeIncludedPincode(index)"
                                >
                                    {{ pincode }}
                                </v-chip>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="excludedPincodeInput"
                                label="Excluded Pincodes"
                                outlined
                                dense
                                maxlength="6"
                                hint="Type 6-digit pincode and press Enter"
                                persistent-hint
                                @input="excludedPincodeInput = normalizePincode(excludedPincodeInput)"
                                @keydown.enter.prevent="addExcludedPincode"
                            ></v-text-field>
                            <div v-if="formData.eligibility_details.excluded_pincode_list.length" class="mt-2">
                                <v-chip
                                    v-for="(pincode, index) in formData.eligibility_details.excluded_pincode_list"
                                    :key="'excluded-' + pincode + index"
                                    class="ma-1"
                                    close
                                    small
                                    @click:close="removeExcludedPincode(index)"
                                >
                                    {{ pincode }}
                                </v-chip>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn text color="error" @click="closeDialog">Cancel</v-btn>
                <v-btn color="success" @click="submitForm" :disabled="!valid || isSubmitting" :loading="isSubmitting">
                    Create Product
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    watch: {
        "formData.product_type_ids"(value) {
            if (!this.formData.eligibility_details.product_type.length) {
                this.formData.eligibility_details.product_type = Array.isArray(value) ? [...value] : [];
            }
        },
    },
    data() {
        return {
            showDialog: false,
            valid: false,
            isSubmitting: false,
            rankRules: [
                (v) => v === "" || v == null || /^[1-9]\d*$/.test(String(v)) || "Whole number, 1 or more",
            ],
            includedPincodeInput: "",
            excludedPincodeInput: "",
            requiredArrayRule: [
                (value) =>
                    (Array.isArray(value) && value.length > 0) || "This field is required",
            ],
            incomeRule: [
                (value) =>
                    !value ||
                    /^\d{1,8}(\.\d{1,2})?$/.test(String(value)) ||
                    "Maximum 8 digits allowed before decimal",
            ],
            formData: {
                name: '',
                title: '',
                logo: null,
                web_url: '',
                utm_link: '',
                product_type_ids: [],
                is_active: true,
                interest_rate: '',
                tenure: '',
                loan_upto: '',
                rank: '',
                flag_recomended: false,
                enable_manual_application : true,
                eligibility_details: {
                    product_type: [],
                    minimum_age: 21,
                    maximum_age: 65,
                    minimum_income: null,
                    maximum_income: null,
                    employment_type: ['Salaried'],
                    salary_type: ['Direct Account Transfer'],
                    cibil_score: 650,
                    pincode_list: [],
                    excluded_pincode_list: []
                }
            },
            productTypes: [],
            employmentTypes: [
                'Salaried',
                'Self Employed',
                'Unemployed'
            ],
            salaryTypes: [
                'Direct Account Transfer',
                'Cash',
                'Cheque'
            ],
        }
    },
    created() {
        this.getProductTypes();
    },
    methods: {
        openDialog() {
            this.showDialog = true;
            this.resetForm();
        },
        closeDialog() {
            this.showDialog = false;
            this.resetForm();
        },
        resetForm() {
            this.includedPincodeInput = "";
            this.excludedPincodeInput = "";
            this.formData = {
                name: '',
                title: '',
                logo: null,
                web_url: '',
                utm_link: '',
                product_type_ids: [],
                is_active: true,
                interest_rate: '',
                tenure: '',
                loan_upto: '',
                rank: '',
                flag_recomended: false,
                enable_manual_application : true,
                eligibility_details: {
                    product_type: [],
                    minimum_age: 21,
                    maximum_age: 65,
                    minimum_income: null,
                    maximum_income: null,
                    employment_type: ['Salaried'],
                    salary_type: ['Direct Account Transfer'],
                    cibil_score: 650,
                    pincode_list: [],
                    excluded_pincode_list: []
                }
            };
            if (this.$refs.productForm) {
                this.$refs.productForm.resetValidation();
            }
        },
        getProductTypes() {
            const self = this;

            const params = { flag_active: false };

            const successHandler = (response) => {
                self.productTypes = response.data.result;
            };

            self.request_GET(
                self,
                self.$urls.GET_LOAN_TYPE,
                params,
                successHandler,
                null,
                null
            );
        },

        toIdArray(value) {
            if (!value) {
                return [];
            }
            return Array.isArray(value) ? value.filter(Boolean) : [value];
        },
        normalizePincode(value) {
            return String(value || "").replace(/\D/g, "").slice(0, 6);
        },
        addPincodeToList(inputValue, listKey, inputKey) {
            const pincode = this.normalizePincode(inputValue);
            if (pincode.length !== 6) {
                this.showSnakeBar("error", "Please enter a valid 6-digit pincode");
                return;
            }
            const list = this.formData.eligibility_details[listKey];
            if (!list.includes(pincode)) {
                list.push(pincode);
            }
            this[inputKey] = "";
        },
        addIncludedPincode() {
            this.addPincodeToList(
                this.includedPincodeInput,
                "pincode_list",
                "includedPincodeInput"
            );
        },
        addExcludedPincode() {
            this.addPincodeToList(
                this.excludedPincodeInput,
                "excluded_pincode_list",
                "excludedPincodeInput"
            );
        },
        removeIncludedPincode(index) {
            this.formData.eligibility_details.pincode_list.splice(index, 1);
        },
        removeExcludedPincode(index) {
            this.formData.eligibility_details.excluded_pincode_list.splice(index, 1);
        },
        buildEligibilityDetails() {
            const details = this.formData.eligibility_details;
            const productTypeIds = this.toIdArray(this.formData.product_type_ids);
            const eligibilityProductTypes = this.toIdArray(details.product_type);
            const selectedProductTypes = eligibilityProductTypes.length
                ? eligibilityProductTypes
                : productTypeIds;

            const sharedDetails = {
                minimum_age: Number(details.minimum_age),
                maximum_age: Number(details.maximum_age),
                minimum_income: details.minimum_income,
                maximum_income: details.maximum_income,
                employment_type: this.toIdArray(details.employment_type),
                salary_type: this.toIdArray(details.salary_type),
                cibil_score: Number(details.cibil_score),
                pincode_list: details.pincode_list || [],
                excluded_pincode_list: details.excluded_pincode_list || [],
            };

            return selectedProductTypes.map((productTypeId) => ({
                ...sharedDetails,
                product_type: productTypeId,
            }));
        },
        submitForm() {
            const self = this;
            if (!this.$refs.productForm.validate()) {
                return;
            }

            const productTypeIds = self.toIdArray(self.formData.product_type_ids);
            if (!productTypeIds.length) {
                self.showSnakeBar("error", "Please select at least one product type");
                return;
            }

            const formData = {
                name: self.formData.name,
                title: self.formData.title,
                web_url: self.formData.web_url,
                utm_link: self.formData.utm_link,
                product_type_ids: productTypeIds,
                is_active: self.formData.is_active,
                interest_rate: self.formData.interest_rate,
                tenure: self.formData.tenure,
                loan_upto: self.formData.loan_upto,
                // A position (1 = shown first), not the raw priority, where a
                // bigger number sorts higher. Omitted = bottom of the list.
                ...(parseInt(self.formData.rank, 10) > 0 ? { rank: parseInt(self.formData.rank, 10) } : {}),
                flag_recomended: self.formData.flag_recomended,
                enable_manual_application: self.formData.enable_manual_application,
                eligibility_details: self.buildEligibilityDetails(),
            };

            self.isSubmitting = true;

            const successHandler = (response) => {
                const detail = response && response.data ? response.data.detail : "";
                if (detail && String(detail).toLowerCase() !== "success") {
                    self.showSnakeBar("error", detail);
                    return;
                }
                self.showSnakeBar("success", "Product created successfully");
                self.showDialog = false;
                self.resetForm();
                self.$emit("created");
            };

            const failureHandler = (error) => {
                const message =
                    self.getApiErrorMessage(error) || "Failed to create product";
                self.showSnakeBar("error", message);
            };

            const finallyHandler = () => {
                self.isSubmitting = false;
            };

            self.request_POST(
                self,
                self.$urls.CREATE_NEW_PRODUCT,
                formData,
                successHandler,
                null,
                failureHandler,
                finallyHandler
            );
        }
    }
}
</script>